import { useLocation, useRevalidator } from "react-router";
import { usePendingLocation } from "./pending-location";
import { searchInputsChanged, type ReadSearch } from "./search-inputs";

/**
 * Whether the route's read is re-running while its previous result stays on
 * screen: an explicit revalidation, or a navigation in flight on this path
 * that changes what the loader reads from the search string — `readSearch`,
 * the reader its `revalidateWhenInputsChange` takes.
 *
 * Not `useNavigation().state`, which is also `loading` while leaving the page
 * and for a search change the loader ignores, whenever a parent loader keeps
 * React Router's default and re-runs on every URL change.
 */
export function useIsRefreshing(readSearch?: ReadSearch): boolean {
  const location = useLocation();
  const pending = usePendingLocation();
  const revalidator = useRevalidator();
  return (
    revalidator.state === "loading" ||
    (readSearch !== undefined && searchInputsChanged(readSearch, location.search, pending.search))
  );
}
